/** Format number with German locale */
export const fmt = (n) => n?.toLocaleString('de-DE') ?? '—';

/** Format currency: +1.234 € or -567 € */
export const fmtEur = (n) => {
  if (n == null) return '—';
  const prefix = n >= 0 ? '+' : '';
  return prefix + n.toLocaleString('de-DE') + ' €';
};

/** Format percentage: 5,2% */
export const fmtPct = (n, decimals = 1) => {
  if (n == null) return '—';
  return n.toFixed(decimals).replace('.', ',') + ' %';
};

/** Format €/m² */
export const fmtSqm = (n) => {
  if (n == null) return '—';
  return n.toLocaleString('de-DE') + ' €/m²';
};
